import { ServerFetch } from '../main-model'

export default class StockZoneModel extends ServerFetch {
    getStockZoneBy = (data) => this.authFetch({
        url: 'stock-zone/getStockZoneBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}